<template>
    <div class="form-container">
        <unavailable-cta>
            This space is not yet published
        </unavailable-cta>

        <div class="space-preview">
            <p>This is just an example of how your space will look once it's completed and bookable by our customers.</p>
        </div>

        <unavailable-buttons v-if="ownsSpace" :space-id="spaceId" :is-complete="false" />
    </div>
</template>

<script>
    import UnavailableCta from '../UnavailableCta';
    import UnavailableButtons from '../UnavailableButtons';

    export default {
        name: 'headers',

        components: { UnavailableCta, UnavailableButtons },

        props: {
            spaceId: {
                type: [String, Number],
                default: null,
            },
            ownsSpace: {
                type: Boolean,
                default: false,
            },
        },
    };
</script>
